<template>
    <v-simple-table
        v-if="discountValue > 0"
        dense
        class="totals-table--bordered"
    >
        <thead>
            <tr>
                <th class="totals-th--bordered">
                    <TranslatableStringComponent :tstring="{string: 'coupon'}" />
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="totals-td--bordered">
                    <div class="d-flex justify-space-between">
                        <div>
                            <span class="font-italic"
                                >{{ couponObj.code }}:</span
                            >
                            <span>-{{ dollars(discountValue) }}</span>
                        </div>
                        <div>
                            <v-btn
                                text
                                small
                                color="#0063a6"
                                @click="handleRemoveCoupon()"
                                ><TranslatableStringComponent :tstring="{string: 'remove'}" /></v-btn
                            >
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'CouponSection',
    components: {
        TranslatableStringComponent,
    },
    data() {
        return { attrs: null }
    },
    computed: {
        ...mapGetters({
            discountValue: 'coupon/discountValue',
        }),
        ...mapState('coupon', ['couponObj']),
    },
}
</script>

<style></style>
